var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.config),expression:"config"}],attrs:{"type":"text"},domProps:{"value":_vm.display},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }